define("shared/components/shared/expandable-radio-card", ["exports", "@ember/component", "@ember/object", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _utils, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _handleToggleActions;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <label class="u--block u--m__b__0" for={{@id}} tabindex="0">
    <div
      class={{concat-classes "cMH--upgradeCard" (if this.isExpanded "is--active")}}
      data-test-id="expandable-radio-card"
      ...attributes
    >
      <div class="cMH--upgradeCard__input">
        <input
          aria-checked={{this.isExpanded}}
          checked={{this.isExpanded}}
          class="u--m__r__sm"
          data-test-id="expandable-radio-card-input"
          id={{@id}}
          name={{@name}}
          tabindex="0"
          type="radio"
          {{did-insert this.addEventListeners}}
          {{on "change" this.toggleExpanded}}
        />
        <span class="u--block u--text--bold">
          {{@title}}
        </span>
      </div>
      {{#if this.isExpanded}}
        <div class="cMH--upgradeCard__desc u--m__b__0 u--p__t" data-test-id="expandable-radio-card-content">
          {{yield}}
        </div>
      {{/if}}
    </div>
  </label>
  */
  {
    "id": "gdw2oHOa",
    "block": "[[[10,\"label\"],[14,0,\"u--block u--m__b__0\"],[15,\"for\",[30,1]],[14,\"tabindex\",\"0\"],[12],[1,\"\\n  \"],[11,0],[16,0,[28,[37,0],[\"cMH--upgradeCard\",[52,[30,0,[\"isExpanded\"]],\"is--active\"]],null]],[24,\"data-test-id\",\"expandable-radio-card\"],[17,2],[12],[1,\"\\n    \"],[10,0],[14,0,\"cMH--upgradeCard__input\"],[12],[1,\"\\n      \"],[11,\"input\"],[16,\"aria-checked\",[30,0,[\"isExpanded\"]]],[16,\"checked\",[30,0,[\"isExpanded\"]]],[24,0,\"u--m__r__sm\"],[24,\"data-test-id\",\"expandable-radio-card-input\"],[16,1,[30,1]],[16,3,[30,3]],[24,\"tabindex\",\"0\"],[24,4,\"radio\"],[4,[38,2],[[30,0,[\"addEventListeners\"]]],null],[4,[38,3],[\"change\",[30,0,[\"toggleExpanded\"]]],null],[12],[13],[1,\"\\n      \"],[10,1],[14,0,\"u--block u--text--bold\"],[12],[1,\"\\n        \"],[1,[30,4]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,0,[\"isExpanded\"]],[[[1,\"      \"],[10,0],[14,0,\"cMH--upgradeCard__desc u--m__b__0 u--p__t\"],[14,\"data-test-id\",\"expandable-radio-card-content\"],[12],[1,\"\\n        \"],[18,5,null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@id\",\"&attrs\",\"@name\",\"@title\",\"&default\"],false,[\"concat-classes\",\"if\",\"did-insert\",\"on\",\"yield\"]]",
    "moduleName": "shared/components/shared/expandable-radio-card.hbs",
    "isStrictMode": false
  });
  let ExpandableRadioCardComponent = _exports.default = (_class = (_handleToggleActions = /*#__PURE__*/new WeakSet(), class ExpandableRadioCardComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _handleToggleActions);
      _defineProperty(this, "inputElement", null);
      _initializerDefineProperty(this, "isExpanded", _descriptor, this);
      _defineProperty(this, "toggleExpanded", () => {
        if (this.isExpanded !== this.inputElement?.checked) {
          this.isExpanded = !this.isExpanded;
          _classPrivateMethodGet(this, _handleToggleActions, _handleToggleActions2).call(this);
        }
      });
    }
    addEventListeners(inputElement) {
      this.inputElement = inputElement;
      inputElement.addEventListener('synchronize-radio-card-group', this.toggleExpanded);
    }
    willDestroy() {
      super.willDestroy();
      this.inputElement?.removeEventListener('synchronize-radio-card-group', this.toggleExpanded);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isExpanded", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "addEventListeners", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addEventListeners"), _class.prototype)), _class);
  function _handleToggleActions2() {
    if (this.isExpanded && (0, _utils.isPresent)(this.args.onExpandedAction)) {
      this.args.onExpandedAction();
    }
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ExpandableRadioCardComponent);
});